import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.AccessLog.List.IRequest;
type Response = Api.Core.AccessLog.List.IResponse;
type Headers = Api.Core.AccessLog.List.IHeaders;
const url = '/api/Management/AccessLog';
export default async function accessLogListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
